import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';

// Build responsive image attributes from the image_scales that plone.restapi
// adds to an image reference inside block data.

type Scale = { download: string; width: number; height: number };

type ImageRef = {
  '@id': string;
  image_scales?: { image?: Array<Scale & { scales?: Record<string, Scale> }> };
};

export type ImageSources = { src: string; srcSet?: string; sizes?: string };

// `fallback` is the scale name used when the reference carries no scales.
export function imageSources(
  ref: ImageRef | undefined,
  fallback: string,
  sizes = '100vw',
): ImageSources | null {
  if (!ref?.['@id']) return null;
  const base = flattenToAppURL(ref['@id']);
  const info = ref.image_scales?.image?.[0];
  const scales = info?.scales
    ? Object.values(info.scales)
        .filter((scale) => scale.width >= 400)
        .sort((a, b) => a.width - b.width)
    : [];
  if (scales.length === 0) {
    return { src: `${base}/@@images/image/${fallback}` };
  }
  const largest = scales[scales.length - 1];
  return {
    src: `${base}/${largest.download}`,
    srcSet: scales
      .map((scale) => `${base}/${scale.download} ${scale.width}w`)
      .join(', '),
    sizes,
  };
}

// The server renders the page with the internal API host in each '@id'.
// Browsers and crawlers cannot reach that host, so keep only the app path.
export const imageScaleUrl = (
  ref: { '@id'?: string } | null | undefined,
  scale: string,
): string => `${flattenToAppURL(ref?.['@id'] ?? '')}/@@images/image/${scale}`;
